export { FranchisePoster } from './FranchisePoster'
